import { connect } from 'react-redux';
import { IState } from '@store/webInterfaces';
import { IProfile } from '@common/domain/models/Profile';
import { fetchUserInstitute } from '@common/redux/institutes/actions';
import { updateProfileDetails } from '@common/redux/profile/actions';
import { updateUserSettings } from '@common/redux/settings/actions';
import { fetchProfileUserDetailsSelector, updateProfileErrorSelector, updateProfileLoaderSelector } from '@common/redux/profile/selectors';
import ProfileCompletion from '@presentation/profileCompletion';

export const mapStateToProps = (state: IState) => ({
  userProfile: fetchProfileUserDetailsSelector(state),
  updateProfileError: updateProfileErrorSelector(state),
  isProfileUpdating: updateProfileLoaderSelector(state),
});

export const mapDispatchToProps = (dispatch: any) => ({
  updateProfile: (profile: IProfile, userId: string) => dispatch(updateProfileDetails(profile, userId)),
  fetchUserInstitute: (payload) => dispatch(fetchUserInstitute(payload)),
  updateUserSettings:(payload) => dispatch(updateUserSettings(payload))
});


export default connect(mapStateToProps, mapDispatchToProps)(ProfileCompletion);
